import { useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import { useFlag } from '../../services/launchDarkly';

import classes from './GamesHero.module.scss';
import oldClasses from './GamesHeroOldSearch.module.scss';

export function useGamesHeroHeight() {
  const [gamesHeroHeight, setGamesHeroHeight] = useState(0);
  const isOldSearchMode = useFlag('enable_old_search_mode', false);

  const listener = debounce((entries: ResizeObserverEntry[]) => {
    for (const entry of entries) {
      const { height } = entry.contentRect;
      setGamesHeroHeight(height);
    }
  }, 60);

  useEffect(() => {
    const headerClass = isOldSearchMode ? oldClasses.gamesHero : classes.gamesHero;
    const heroImage = document.querySelector<HTMLDivElement>(`.${headerClass}`);

    if (!heroImage) {
      return;
    }

    const resizeObserver = new ResizeObserver(listener);

    resizeObserver.observe(heroImage);

    return () => {
      resizeObserver.disconnect();
    };
  }, [listener, isOldSearchMode]);

  return { gamesHeroHeight };
}
